import Vue from 'vue';

Vue.mixin({
  computed: {
    LeadStatusFavor() {
      let defaultStatus = this.$store.state.leadStatusFavorDefault;
      let favorStatus = this.$store.state.leadStatusFavorCustom;

      return defaultStatus.length ? defaultStatus : favorStatus;
    }
  },
  methods: {}
});
